import { TableV2 } from '@anytag/shared-atoms';
import { TableData } from '@anytag/shared-types';
import { TikTokSpecialCampaign } from '@anytag/graphql';
import { useTikTokCampaignsTable } from './hooks';

export type TikTokCampaignsListProps = TableData<TikTokSpecialCampaign>;

export const TikTokCampaignsList = ({ loading, data = [] }: TikTokCampaignsListProps) => {
  const { columns } = useTikTokCampaignsTable();

  return <TableV2 data={data} loading={loading} columns={columns} noTopBorderRadius hasBorder />;
};
